<!--
 * @Author: Jarun
 * @Date: 2021-03-22 17:06:11
 * @LastEditTime: 2021-03-25 15:43:48
 * @LastEditors: Please set LastEditors
 * @Description: demo
 * @FilePath: \box.mengw.com\src\views\Demo\Demo.vue
-->

<template>
    <div class="forum_detail">
        <div class="nav_wrap">
            <NavBar :border="false" fixed placeholder @click-left="back" @click-right="openMenu">
                <template #left>
                    <img class="back_icon" src="@/assets/images/atmosphere/icon_back.png" alt="返回">
                    <forum-head :date="thread.publish_time" :achievement="achievement" :delFun="deleteForum" :showDel="user.user_id == userInfo.user_id" :user="user" :topTag="thread.sub_forum_name" :views="thread.views" type="detail"></forum-head>
                </template>
                <template #right>
                    <img class="open_menu" src="@/assets/images/common/icon_menu_round.png" alt="">
                </template>
            </NavBar>
        </div>

        <div class="scroll_wrapper">
            <div class="refresh_wrap">
                <span v-if="isRefreshing"><Loading color="#333" size="24px">加载中...</Loading></span>
                <span v-else>{{refreshTxt}}</span>
            </div>

            <!-- <div class="user_info">
                <forum-head :date="thread.publish_time" :achievement="achievement" :delFun="deleteForum" :showDel="user.user_id == userInfo.user_id" :user="user" :topTag="thread.sub_forum_name" :views="thread.views" type="detail"></forum-head>
            </div> -->
            <div class="short_forum_content_wrap" v-if="type_id == 1">
                <div class="forum_img_box" v-if="thread.images.length > 0">
                    <Swipe :stop-propagation="true" class="my-swipe">
                        <SwipeItem v-for="(v, index) in thread.images" :key="index" class="swipe_item" @click="viewImage(v, index)">
                            <img :src="v" alt="" class="swipe_img" />
                        </SwipeItem>
                    </Swipe>
                </div>
                <div class="content">
                    <div class="forum_title" v-html="thread.subject"></div>
                    <div class="forum_content" v-html="thread.content" ref="contentRef"></div>
                    <div class="video_wrapper" v-if="thread.video_url">
                        <Video
                            ref="videoCom"
                            :videoData="{ video: thread.video_url, cover: thread.cover_url }"
                            :videoConfig="{
                                autoplay: false,
                                muted: true,
                                loop: true,
                                controls: true
                            }"
                        />
                    </div>
                </div>
            </div>
            <div class="content_wrap" v-else>
                <div class="forum_title" v-html="thread.subject"></div>
                <div class="forum_content" v-html="thread.content" ref="contentRef"></div>
                <!-- <iframe
                    name="link_jump"
                    width="100%"
                    height="400"
                    frameborder="0"
                ></iframe> -->
                <!-- <div class="img_wrap">
                    <image-handle :images="thread.images"></image-handle>
                </div> -->
                <div class="video_wrapper" v-if="thread.video_url">
                    <Video
                        ref="videoCom"
                        :videoData="{ video: thread.video_url, cover: thread.cover_url }"
                        :videoConfig="{
                            autoplay: false,
                            muted: true,
                            loop: true,
                            controls: true
                        }"
                    />
                </div>
            </div>
            <div class="dateAndView">
                <div class="date">{{ thread.publish_time ? util.timeHandle(thread.publish_time) : '00:00'}}</div>
                <div class="views">{{ thread.views }}浏览</div>
            </div>
            <div class="superTopicList" v-if="thread.super_topics">
                <div class="superTopicItem" v-for="(v, index) in thread.super_topics" :key="index" @click="goSuperTopic(v)"># {{v.name}}</div>
            </div>
            <div v-if="thread.sub_forum_name&&thread.sub_forum_name=='问答'">
                <div class="mine_posts_like">
                    <div><img src="@/assets/images/forum/icon_say.png"/>{{thread.posts}}</div>
                    <div><img src="@/assets/images/forum/icon_praise.png"/>{{thread.likes}}</div>
                    <!-- <div><img src="@/assets/images/forum/icon_star.png"/></div>   -->
                </div>
                <div class="mine_invite">
                    <div @click="goState({name: 'attention', params:{tid: thread.tid}})"><img src="@/assets/images/forum/icon_invite.png"/>邀请回答</div>
                </div>
            </div>
            <!-- <div class="posts_like" v-else>
                <div class="posts_num active">回复 {{thread.posts}}</div>
                <div class="posts_num">赞 {{thread.likes}}</div>
            </div> -->
            <div class="comment_wrapper" ref="commentRef">
                <div class="filter_wrap">
                    <div class="text"></div>
                    <Popover v-model:show="showCommentFilter" class="forum_detail_popover" :actions="commentFilterActions" @select="commentFilterSelect" teleport="#app">
                        <template #reference>
                            <div class="filter_icon">
                                {{filterSelect.text}}
                                <img src="@/assets/images/forum/icon_filter.png" alt="">
                            </div>
                        </template>
                    </Popover>
                </div>
                <div class="comment_list" v-if="replyList && replyList.length > 0 && isRefresh">
                    <comment-model :deleteComment="deleteComment" :isLikesFun="goLike" v-for="v in replyList" :key="v.pid" :commentData="v" :showMenuPop2="showMenuPop2" @click.stop="showMenuPop(v)" @commentModelRefresh="commentModelRefresh" @commentModelBtn="commentModelBtn"></comment-model>
                </div>
                <empty-status v-if="replyList && replyList.length <= 0"></empty-status>
            </div>

            <div class="refresh_bottom">{{refreshUptxt}}</div>
        </div>
    </div>

    <comment-menu v-if="showReplyMenuPop" :showMenu="showReplyMenuPop" @closeMenu="showReplyMenuPop = false" :replyUserId="selectItemMenuData.rid" :replyId="selectItemMenuData.pid" :contentText="selectItemMenuData.content" :type="selectItemMenuData.type" :callback="changeList"></comment-menu>
    <share-popup :forumId="thread.tid" :showShare="showShare" @closeShare="showShare = false" :shareData="shareData" type="forum" :reqCollect="reqCollect" :is_favor="thread.user_favorite==0?false:true"></share-popup>

    <div class="comment_bar">
        <Button v-if="thread.is_reply == 1" class="input_btn" @click="userComment" ref="commentBtnRef">写下您的想法...</Button>
        <Button v-else class="input_btn">当前禁止评论</Button>
        <forum-foot :commentFun="userComment" :collectFun="reqCollect" :likeFun="userLike" :isForumDetail="true" :userFavorite="thread.user_favorite" :userLike="thread.user_like" :posts="thread.posts" :likes="thread.likes"></forum-foot>
    </div>

    <!-- S 回复弹窗 -->
    <comment-popup :show="showCommentPop" @showCommentPopup="showCommentPopup" :type="commentType" :id="commentForumId" :callback="changeList"/>

    <!-- E 回复弹窗 -->
</template>

<script lang="js">
import { defineComponent, ref, reactive, toRefs, watch, onBeforeMount, onMounted, onActivated, onDeactivated, computed, nextTick } from 'vue';
import { useRoute } from "vue-router"
import { Button, NavBar, Popover, Loading, Dialog, Swipe, SwipeItem, ImagePreview  } from 'vant';
import router from '@/router';
import { useStore } from 'vuex';
import Util from '@/assets/js/lib/util';
import ForumHead from '@/components/Seven_ForumHead/ForumHead.vue';
import ForumFoot from '@/components/Seven_ForumFoot/ForumFoot.vue';
import ImageHandle from '@/components/Seven_ImageHandle/ImageHandle.vue';
import CommentModel from '@/components/Git_CommentModel/CommentModel.vue';
import EmptyStatus from "@/components/Seven_EmptyStatus/EmptyStatus.vue";
import CommentMenu from '@/components/Seven_CommentMenu/CommentMenu.vue';
import SharePopup from '@/components/Seven_SharePopup/SharePopup.vue';
import CommentPopup from '@/components/Comment_Popup/Comment_Popup.vue';
import BScroll from '@better-scroll/core'
import MouseWheel from '@better-scroll/mouse-wheel'
import Pulldown from '@better-scroll/pull-down'
import Pullup from '@better-scroll/pull-up'
import ObserveImage from '@better-scroll/observe-image'
BScroll.use(MouseWheel)
BScroll.use(Pullup)
BScroll.use(Pulldown)
BScroll.use(ObserveImage)
import { onBeforeRouteLeave } from "vue-router";
import Video from "@/components/Video/Video.vue";

export default defineComponent({
    name: 'ForumDetail',
    components: { Button, NavBar, ForumHead, ForumFoot, ImageHandle, Popover, CommentModel, Loading, Dialog, EmptyStatus, Video, CommentMenu, SharePopup, CommentPopup, Swipe, SwipeItem},
    setup(props, { attrs, slots }) {
        const store = useStore();
        const route = useRoute()
        const state = reactive({
            util: new Util(),
            showCommentFilter: false,
            commentFilterActions: [{ text: '按回复时间倒序', color: '#FA1919', id: 1 }, { text: '按回复时间正序', color: '#B5B4B4', id: 2 }, { text: '按点赞数多到少', color: '#B5B4B4', id: 3 },],
            filterSelect: { text: '按回复时间倒序', color: '#FA1919', id: 1 },
            bs: '',
            refreshTxt: '', //下拉刷新的文本
            isRefreshing: false, //是否正在刷新中
            page: 1,
            total: 1,
            limit: 10,
            refreshUptxt: '',
            pageId: '',
            commentRef: '', //评论区的ref，为了scrollTo的坐标
            commentBtnRef:'', //评论输入框
            contentRef: ref(),
            videoCom: null,
            selectItemMenuData: {}, //被选中的回复
            showReplyMenuPop: false,
            showShare: false,
            shareData: {}, //分享数据
            type: 0, //判断是否从我的里面进入，1代表从我的问答里面进入

            /* 弹框所需的字段S */
            showCommentPop: false, //评论的弹窗
            commentType: '',//评论的类型
            commentForumId:'',//评论的id
            isRefresh: true,
            /* 弹框所需的字段E */

            type_id: 0, //判断帖子类型，0：长贴、提问；1：动态

        });
        const data = reactive({
            thread: {},
            achievement: [],
            user: {},
            replyList: []
        });

        onMounted(() => {
            reqForumDetail();
            reqForumReply();
            state.pageId = router.currentRoute.value.params.id;
            state.type = router.currentRoute.value.params.type;
            console.log('contentRef', state.contentRef)
            state.contentRef.addEventListener('click', (event) => {
                event.preventDefault();
            })
            setTimeout(() => {
                if(state.contentRef.getElementsByTagName('a').length != 0) {
                    for(let i = 0; i < state.contentRef.getElementsByTagName('a').length; i++) {
                        state.contentRef.getElementsByTagName('a')[i].target = 'link_jump';
                        state.contentRef.getElementsByTagName('a')[i].addEventListener('click', (event) => {
                            methods.goState({name: 'iframe-view', query: {url: state.contentRef.getElementsByTagName('a')[i].href, name: router.currentRoute.value.name}})
                        })
                    }
                }
            }, 400)
        });

        onActivated(async () => {
            const { id: post_id = ''} = router.currentRoute.value.params;
            const { is_announce = ''} = router.currentRoute.value.query;
            if(is_announce){
                state.util.enterStat('circle_browse_post', {post_id, is_announce});
            }
            state.type = router.currentRoute.value.params.type;
            await reqForumDetail();
            let y = state.bs.y;

            scrollInit();
            scrollHandle();

            if(state.pageId != router.currentRoute.value.params.id){

                state.page = 1;
                state.total = 1;
                await reqForumReply();

                state.bs.scrollTo(0, 0)
                setTimeout(() => {
                    state.bs.refresh();
                }, 100);
            }else {
                await changeList();

                if(y){
                    state.bs.scrollTo(0, y)
                }

                setTimeout(() => {
                    state.bs.refresh();
                }, 500);
            }

            state.pageId = router.currentRoute.value.params.id;
            document.addEventListener('touchmove', methods.preventDefault, {passive: false})

            state.contentRef.addEventListener('click', (event) => {
                event.preventDefault();
            })
            setTimeout(() => {
                if(state.contentRef.getElementsByTagName('a').length != 0) {
                    for(let i = 0; i < state.contentRef.getElementsByTagName('a').length; i++) {
                        state.contentRef.getElementsByTagName('a')[i].target = 'link_jump';
                        state.contentRef.getElementsByTagName('a')[i].addEventListener('click', (event) => {
                            methods.goState({name: 'iframe-view', query: {url: state.contentRef.getElementsByTagName('a')[i].href, name: router.currentRoute.value.name}})
                        })
                    }
                }
            }, 400)
        });

        onDeactivated(() => {
            state.bs.destroy();
            document.removeEventListener('touchmove', methods.preventDefault, {passive: false})
        });

        const scrollInit = () => {
            state.bs = new BScroll('.forum_detail',{
                scrollY: true,
                // click: true,
                probeType: 3,
                // 启用鼠标滚轮插件
                mouseWheel: {
                    speed: 40, // 滚动速度
                    invert: false, // 滚轮方向与滚动方向是否相反
                    dampingFactor: 0.05, // 阻尼系数，用于模拟真实滚动感
                    easeTime: 300 // 动画缓动时间
                },
                bounceTime: 400,
                outOfBoundaryDampingFactor: 0.2,
                specifiedIndexAsContent: 1,
                deceleration: 0.009,
                swipeBounceTime: 400,
                pullDownRefresh: {
                    threshold: 50,
                    stop: 40 //这样就会回到顶部了
                },
                pullUpLoad: { //上拉加载
                    threshold: 20
                },
                observeImage: true,
                preventDefault: false,
            })

            state.bs.on('scroll',  (position) => {
                if(position.y < 0){
                    state.refreshTxt = ''
                }else if(position.y < 38){
                    state.refreshTxt = '下拉刷新';
                    state.isRefreshing = false;
                    state.bs.finishPullDown();
                }else {
                    state.refreshTxt = '释放刷新'
                }
            });

            state.bs.on('pullingDown', async () => {
                state.isRefreshing = true;
                await reqForumDetail();
                state.page = 1;
                state.total = 1;
                await reqForumReply();
                methods.refreshReplylist();
                setTimeout(() => {
                    window.Components.toast('刷新成功')
                    state.bs.finishPullDown();
                    state.bs.finishPullUp();
                    state.bs.refresh();
                }, 300);
            })

            state.bs.on('pullingUp', async () => {
                if(state.page > state.total){
                    state.refreshUptxt = '暂无更多数据';
                    return
                }

                state.refreshUptxt= '加载更多';

                await reqForumReply(true);

                setTimeout(() => {
                    state.bs.finishPullUp();
                    state.bs.refresh();
                }, 300);
            })

            setTimeout(() => {
                state.bs.refresh();
            }, 500);
        };

        const reqForumDetail = async () => { //请求帖子详情
            const res = await state.util.getJson('/thread/detail', 'GET', {tid: router.currentRoute.value.params.id}, true);
            if(res.code == 0){
                res.data.thread.content = methods.decodeHtml(res.data.thread.content);
                data.thread = res.data.thread;
                data.achievement = res.data.achievement;
                state.type_id = res.data.thread.type;
                methods.handleImageLoad();
                const list = res.data.thread;
                const videoIdList = [];
                if(list.video) {
                    videoIdList.push(list.video);
                }
                const videoRes = await state.util.getVideoInfo(videoIdList);
                if(videoRes.code == 0) {
                    for (const elementVideoRes of videoRes.data) {
                        if (data.thread.video === elementVideoRes.asset_id) {
                            data.thread.cover_url = elementVideoRes.cover_url;
                            data.thread.video_url = elementVideoRes.video_url;
                            break;
                        }
                    }
                }
                data.user = res.data.user;
                if(res.data.thread.is_official == 1){
                    data.thread.content = state.util.encodeContent(res.data.thread.content);
                }else{
                    data.thread.content = state.util.encodeContent(res.data.thread.content);
                }

                state.shareData = {
                    icon : data.thread.images.length != 0 ? data.thread.images[0] : "",
                    title : data.thread.subject,
                    desc :  data.thread.content
                }
            }else {
                window.Components.toast(res.msg)
            }
        };


        const reqForumReply = async (flag = false) => { //请求评论列表
            let params = {
                tid: router.currentRoute.value.params.id,
                page: state.page,
                per_page: state.limit,
                sort: state.filterSelect.id
            };
            const res = await state.util.getJson('/thread/commentList', 'GET', params, true);
            if(res.code == 0){

                if(flag){ //加载更多
                console.info(1)
                    data.replyList.push(...res.data.comments);
                }else{ //刷新
                    if(res.data.comments && res.data.comments.length > 0){
                        data.replyList = res.data.comments;
                    }else{
                        data.replyList = [];
                    }
                }

                state.page += 1;
                if(res.data.total > 1){
                    state.total = res.data.total;
                };
                setTimeout(() => {
                    state.bs.refresh();
                }, 500);
            }else {
                window.Components.toast(res.msg)
            }
        };

        const changeList = async () => { //局部刷新数据
            let params = {
                tid: router.currentRoute.value.params.id,
                page: 1,
                per_page: state.limit * (state.page - 1 < 1 ? 1 : state.page - 1),
                sort: state.filterSelect.id,
            }
            const res = await state.util.getJson('/thread/commentList', 'GET', params, true);
            if(res.code == 0){
                if(res.data.comments && res.data.comments.length > 0){
                    data.replyList = res.data.comments;
                }else{
                    data.replyList = [];
                }

                setTimeout(() => {
                    state.bs.refresh();
                }, 500);
            }else {
                window.Components.toast(res.msg)
            }
        }

        const reqDelete = async () => { //删除主题
            const res = await state.util.getJson('/thread/delete', 'POST', {tid: router.currentRoute.value.params.id}, true);

            if(res.code == 0){
                window.Components.toast('删除成功');
                methods.back();
            }else {
                window.Components.toast(res.msg)
            }
        }

        const reqDelComment = async (params) => { //删除评论
            const res = await state.util.getJson('/thread/commentDelete', 'POST', params, true);

            if(res.code == 0){
                window.Components.toast('删除成功');
                changeList()
            }else {
                window.Components.toast(res.msg)
            }
        }

        const scrollHandle = () => {
            if(router.currentRoute.value.query.type &&  router.currentRoute.value.query.type == 'comment'){
                setTimeout(() => {
                    state.bs.scrollToElement(state.commentRef, 300, false, false)
                }, 1000);
            }
        };

        const reqShamPraise = async (params) => { //虚假更新点赞



            if(params.type == 2){
                data.replyList.forEach((item,index) => {
                    if(item.tid == params.tid && item.pid == params.comment_id){
                        data.replyList[index].user_like = params.status
                        if(data.replyList[index].user_like == 1){
                            data.replyList[index].likes += 1
                        }else{
                            data.replyList[index].likes -= 1
                        }
                    }
                });
            }else{
                    if(data.thread.tid == params.tid){
                        data.thread.user_like = params.status
                        if(data.thread.user_like == 1){
                            data.thread.likes += 1
                        }else{
                            data.thread.likes -= 1
                        }
                    }
            }
        };

        const methods = {
            back: () => {
                data.thread= {};
                data.user= {};
                data.replyList= [];
                if(window.history.state&&window.history.state.back){
                    router.back()
                }else{
                    router.push({
                        path: '/'
                    })
                }
            },
            goState: o => router.push(o),
            commentFilterSelect: async (action) => {
                state.filterSelect = action;

                state.commentFilterActions.map((v) => {
                    if(v.text == action.text){
                        v.color = '#FA1919';
                    }else{
                        v.color = '#B5B4B4';
                    }
                })

                state.page = 1;
                state.total = 1;
                await reqForumReply();
                setTimeout(() => {
                    state.bs.refresh();
                }, 400);
            },
            goLike: async (o) => {//点赞事件
                const res = await state.util.getJson('/thread/like', 'POST', o, true);
                if(res.code == 0){
                    await reqShamPraise(o);

                    setTimeout(() => {
                        state.bs.refresh();
                    }, 300);
                }else {
                    window.Components.toast(res.msg)
                }
            },
            userLike: async () => {
                if (!state.util.getCookieLocalStorage('access_token')) {
                    state.util.login({ query: { routerurl: router?.options?.history?.state?.current } }, 'replace')
                    return false;
                }
                let params = {
                    tid: router.currentRoute.value.params.id,
                    type: 1,
                    status: data.thread.user_like == 0 ? 1 : 0,
                };
                methods.goLike(params);
            },
            userComment: () => {
                state.commentType = 'forum'
                state.commentForumId = data.thread.tid
                state.showCommentPop = true
            },
            deleteForum: () => {
                Dialog.confirm({
                    title: '删除主题',
                    message: '是否确定删除此主题',
                })
                .then(() => {
                    reqDelete();
                })
                .catch(() => {});
            },
            deleteComment: (params) => {
                Dialog.confirm({
                    title: '删除评论',
                    message: '是否确定删除此条评论',
                })
                .then(() => {
                    reqDelComment({id: params.pid, type: 1});
                })
                .catch(() => {});
            },
            showMenuPop: (data) => {
                state.selectItemMenuData = data;
                state.selectItemMenuData.type = 'reply';
                state.showReplyMenuPop = true;
            },
            showMenuPop2: (data) => {
                state.selectItemMenuData = data;
                state.selectItemMenuData.type = 'replyUser';
                state.showReplyMenuPop = true;
            },
            openMenu: () => {
                setTimeout(() => {
                    state.showShare = true;
                }, 100);
            },
            reqCollect: async () => { //请求和取消收藏
                if (!state.util.getCookieLocalStorage('access_token')) {
                    state.util.login({ query: { routerurl: router?.options?.history?.state?.current } }, 'replace')
                    return false;
                }
                const status = data.thread.user_favorite == 0?1:0;
                const res = await state.util.getJson('/thread/favor', 'POST', {tid: data.thread.tid, status: status}, true);
                if(res.code == 0){
                    if(data.thread.user_favorite == 0){
                        window.Components.toast("收藏成功");
                    }else{
                        window.Components.toast("取消收藏成功");
                    }
                    await reqForumDetail();
                }else {
                    window.Components.toast(res.msg)
                }
            },
            showCommentPopup: (val) => {
                setTimeout(() => {
                    state.showCommentPop = val
                }, 100);
            },
            commentModelBtn: (object) => {
                state.commentType = object.type
                state.commentForumId = object.id
                setTimeout(() => {
                    state.showCommentPop = true
                }, 100);
            },
            preventDefault: (e) => {
                if (e._isScroller) return;
                // 阻止默认事件
                e.preventDefault();
            },
            commentModelRefresh: () => {
                setTimeout(() => {
                    state.bs.refresh();
                }, 300)
            },
            refreshReplylist: () => {
                //刷新评论区
                state.isRefresh = false;
                nextTick(() => {
                    state.isRefresh = true;  // 在下一个DOM更新周期重新挂载
                });
            },
            goSuperTopic: (item) => {
                //跳转超级话题页
                methods.goState({name: 'superTopic', query: {id: item.id}})
            },
            // 使用 DOMParser 进行解码
            decodeHtml: (html) => {
                // 使用正则表达式全局匹配 &amp; 并替换为 &
                return html.replace(/&amp;/g, '&');
            },
            viewImage: (img, index) => {
                //图片预览
                ImagePreview({
                    images: data.thread.images,
                    startPosition: index
                });
            },
            handleImageLoad: () => {
                const imgArr = document.getElementsByClassName('swipe_img')
                const swipe = document.getElementsByClassName('my-swipe')
                const swipeItem = document.getElementsByClassName('swipe_item')
                if(imgArr.length > 0) {
                    let naturalWidth = imgArr[0].naturalWidth
                    let naturalHeight = imgArr[0].naturalHeight
                    if((naturalWidth / naturalHeight) <= 3/4) {
                        for(let i = 0; i < imgArr.length; i++) {
                            imgArr[i].style.height = '133.3vw'
                        }
                    }else if((naturalWidth / naturalHeight) <= 1) {
                        for(let i = 0; i < imgArr.length; i++) {
                            imgArr[i].style.height = '100vw'
                        }
                    }else {
                        for(let i = 0; i < imgArr.length; i++) {
                            imgArr[i].style.height = '75vw'
                        }
                    }
                }
            }
        }

        onBeforeRouteLeave((to, from) => {
            if(state.util.leaveIntercept(to)) return true; else return false;
        });

        return {
            ...toRefs(state),
            ...toRefs(data),
            ...methods,
            userInfo: computed(() => store.state.userInfo),
            changeList,
        };
    },
});
</script>

<style lang="less" scoped>
@charset "utf-8";
@import "./ForumDetail.less";
</style>
